import auth from './auth';
import axios from 'axios';

// Add a request interceptor
axios.interceptors.request.use(
    function(config) {
        config.headers.Authorization = localStorage.getItem('id_token');
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function(response) {
        if (response.config.url === '/auth/token' && response.status === 200) {
            let token = response.data.token;
            localStorage.setItem('id_token', token);
        } else {
            auth.checkExpiredToken(response).then(function(response) {
                return response;
            });
        }

        return response;
    },
    function(error) {
        auth.checkExpiredToken(error.response).then(function(response) {
            return response;
        });
        return Promise.reject(error);
    }
);
